export const ENVIRONMENTS = {
  PRODUCTION: 'production',
  TEST: 'test',
};

export type Environments = typeof ENVIRONMENTS[keyof typeof ENVIRONMENTS];
